import  jQuery from 'jquery';
window.jQuery  = jQuery;
$ = jQuery;

import "emojionearea";
import "jquery.scrollto";
import countdown from "countdown";
import vimeoPlayerImport from "@vimeo/player";
import { forceInt, forceFloat } from '../functions';

if (typeof sessionStorage === "undefined") {
    var sessionStorage = {
        getItem: function() {},
        setItem: function() {}
    };
}

function convertMsToSeconds(ms) {
    return forceInt(Math.floor(ms / 1000));
}

function convertSecondsToMs(seconds) {
    return seconds * 1000;
}

class JITWebinar
{
    constructor()
    {

    }

    startTimeInSpecificTimeFromNow(secondsFromStart)
    {
        const currentTimestamp = Math.floor(Date.now() / 1000);

        secondsFromStart = parseInt(secondsFromStart);
        if (isNaN(secondsFromStart)) secondsFromStart = 0;

        let startTimestamp = currentTimestamp + secondsFromStart;
        if (isNaN(startTimestamp)) startTimestamp = 0;

        return startTimestamp;
    }

    startTimeSpecificHour(option)
    {
        var date = new Date(),
            currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 0, 0),
            currentHour = currentDate.getHours(), // the hour of the day in 24 hour time
            startTimestamp = 0;

        if (option.addDays > 0 || (currentHour < option.startHour && ((option.startHour - currentHour) > 0))) {
            if (option.addDays > 0) {
                currentDate.setDate(currentDate.getDate() + option.addDays);
            }
            currentDate.setHours(option.startHour);
            currentDate.setMinutes(0);
            currentDate.setSeconds(0);
            startTimestamp = Math.floor(currentDate.getTime() / 1000);
        }

        return startTimestamp;
    }

    getMsTimestamp(value)
    {
        let startTimestamp = 0;

        const jitWebinarStartTimeOption = jitWebinarStartTimeOptions.find(function(jitWebinarStartTimeOption) {
            return (jitWebinarStartTimeOption.key === value);
        });
        if (jitWebinarStartTimeOption) {
            if (jitWebinarStartTimeOption.func === 'startTimeSpecificHourOfDay') {
                startTimestamp = this.startTimeSpecificHour(jitWebinarStartTimeOption);
                // console.log(value, startTimestamp);
            } else if (jitWebinarStartTimeOption.func === 'startTimeInSpecificTimeFromNow') {
                startTimestamp = this.startTimeInSpecificTimeFromNow(jitWebinarStartTimeOption.secondsFromStart);
                // console.log(value, startTimestamp);
            }
        }

        // if (jitWebinarStartTimeOptions[value]) {
        //     if (jitWebinarStartTimeOptions[value].func === 'startTimeSpecificHourOfDay') {
        //         startTimestamp = this.startTimeSpecificHour(jitWebinarStartTimeOptions[value]);
        //         // console.log(value, startTimestamp);
        //     } else if (jitWebinarStartTimeOptions[value].func === 'startTimeInSpecificTimeFromNow') {
        //         startTimestamp = this.startTimeInSpecificTimeFromNow(jitWebinarStartTimeOptions[value].secondsFromStart);
        //         // console.log(value, startTimestamp);
        //     }
        //     // const startDate = new Date(startTimestamp * 1000);
        //     // let dateFormatted = startDate.toDateString() + ' ' + startDate.toLocaleTimeString();
        // }

        return startTimestamp;
    }

}

$(function() {
    var $jitWebinarJustSignedUp = $('#js_jitWebinarJustSignedUp');
    if ($jitWebinarJustSignedUp.length) {
        if (window.FBPixelDefined) {
            // eventID matches the Conversions API event sent by JITWebinarAttendee::fireSignUpFbEvent() so FB can dedupe them
            const fbEventIDSignUp = $jitWebinarJustSignedUp.data('fb-event-id');
            fbq('track', 'CompleteRegistration', {
                content_name: 'JIT Webinar Attendee Signed Up',
                jit_webinar_name: $jitWebinarJustSignedUp.data('webinar-name'),
                jit_webinar_id: forceInt($jitWebinarJustSignedUp.data('webinar-id'))
            }, (fbEventIDSignUp ? { eventID: fbEventIDSignUp } : {}));
        }

        if (window.GtmDefined) {
            let webinarName = $jitWebinarJustSignedUp.data('webinar-name'),
                webinarStartTime = $jitWebinarJustSignedUp.data('webinar-start-time');
            if (webinarName !== '' && webinarStartTime !== '') {
                const data = {
                    event: 'jitWebinarSignup',
                    detail: {
                        webinarName: webinarName,
                        webinarStartTime: webinarStartTime
                    }
                };
                // console.log(data);
                window.dataLayer.push(data);
            }
        }
    }

    if ($('.JITWebinarPage').length && !$('.JITWebinarPage_live').length) {
        function countdownTimer() {
            if ($('.js-countdown-timer').length) {
                let value = countdown(new Date(jitWebinarMsTimestamp)).toString();
                if (Date.now() > jitWebinarMsTimestamp) {
                    value = hpaTranslatedtext.jitWebinar.webinarHasStarted; // Webinar has started
                    $('.js-countdown-timer').html(value);
                    return true;
                }
                $('.js-countdown-timer').html(value);
                setTimeout(function() {
                    countdownTimer();
                }, 1000);
            }
        }

        const startTimeDropdown = $('#JITWebinarStartTimeOptionsDropdown');
        if (startTimeDropdown.length) {
            // Remove any options that
            startTimeDropdown.find('option').each(function() {
                var $this = $(this),
                    value = $this.val();
                if (value != '') {
                    var classJITWebinar = new JITWebinar(),
                        startTimestamp = classJITWebinar.getMsTimestamp(value);

                    if (startTimestamp === 0) {
                        $this.remove();
                    }
                }
            });
            $('#Form_RegisterForWebinarForm').parsley().on('form:submit', function() {
                const value = startTimeDropdown.val(),
                    classJITWebinar = new JITWebinar(),
                    startTimestamp = classJITWebinar.getMsTimestamp(value);

                $('#Form_RegisterForWebinarForm_WebinarStartTimeOptionKey').val(value);
                $('#Form_RegisterForWebinarForm_WebinarStartTimestamp').val(startTimestamp);

                // console.log('Returning false on form submit. Just for testing.');
                // return false;
            });

            $('.js_JITWebinarFacebookLoginLink').on('click', function(e) {
                e.preventDefault();

                var $this = $(this),
                    value = startTimeDropdown.val(),
                    classJITWebinar = new JITWebinar(),
                    startTimestamp = classJITWebinar.getMsTimestamp(value),
                    redirectURL = $this.data('href');
                redirectURL += '?WebinarStartTimeOptionKey=' + value + '&WebinarStartTimestamp=' + startTimestamp;
                // console.log(redirectURL);

                window.location = redirectURL;
            });
        }
        $('#JITWebinarStartTimeOptionsDropdown').on('change', function() {
            var $this = $(this);

            if ($this.val() != '') {
                $('#Form_RegisterForWebinarForm').show();
            } else {
                $('#Form_RegisterForWebinarForm').hide();
            }
        });

        // const startTimeFieldsUl = $('#Form_RegisterForWebinarForm_WebinarStartTimeOptionKey');
        // if (startTimeFieldsUl.length) {
        //     startTimeFieldsUl.find('li').each(function(i, obj) {
        //         const $this = $(this);
        //         const radioField = $this.find('input[type="radio"]');
        //         if (radioField.length) {
        //             const value = radioField.val();
        //             if (jitWebinarStartTimeOptions[value]) {
        //                 const classJITWebinar = new JITWebinar();
        //                 let startTimestamp = 0;
        //                 if (jitWebinarStartTimeOptions[value].func === 'startTimeSpecificHourOfDay') {
        //                     startTimestamp = classJITWebinar.startTimeSpecificHour(jitWebinarStartTimeOptions[value].startHour);
        //                     // console.log(value, startTimestamp);
        //                 } else if (jitWebinarStartTimeOptions[value].func === 'startTimeInSpecificTimeFromNow') {
        //                     startTimestamp = classJITWebinar.startTimeInSpecificTimeFromNow(jitWebinarStartTimeOptions[value].secondsFromStart);
        //                     // console.log(value, startTimestamp);
        //                 }
        //                 if (startTimestamp === 0) {
        //                     $this.hide();
        //                 }
        //                 const startDate = new Date(startTimestamp * 1000);
        //                 let dateFormatted = startDate.toDateString() + ' ' + startDate.toLocaleTimeString();
        //                 // console.log('startDate', dateFormatted);
        //                 $this.find('label').html($this.find('label').text() + '<br /><small>' + dateFormatted + '</small>');
        //                 $this.data('timestamp', startTimestamp);
        //
        //                 if (i === 0) $('#Form_RegisterForWebinarForm_WebinarStartTimestamp').val(startTimestamp);
        //             }
        //         }
        //
        //     });
        //     startTimeFieldsUl.find('li').on('click', function() {
        //         const $this = $(this);
        //
        //         $('#Form_RegisterForWebinarForm_WebinarStartTimestamp').val($this.data('timestamp'));
        //     });
        // }

        if ($('.js-countdown-timer').length) {
            const jitWebinarDate = new Date(jitWebinarMsTimestamp);

            countdownTimer();
            if ($('.js-jit-webinar-date').length) {
                $('.js-jit-webinar-date').each(function() {
                    const $this = $(this),
                        format = $this.data('format');
                    let dateText = '';
                    if (typeof format.minute !== 'undefined') {
                        dateText = jitWebinarDate.toLocaleTimeString(
                            'en-US',
                            format
                        );
                    } else {
                        dateText = jitWebinarDate.toLocaleDateString(
                            'en-US',
                            format
                        );
                    }
                    $this.text(dateText);
                });
            }
        }

        // $('#JITWebinarStartTimeOptionsDropdown').chosen({width: '100%'});

        $('.jit-video-trigger').on('touch click', function(e) {
            e.preventDefault();

            const triggered = $(this).attr("data-triggered");
            if (triggered) {
                return false;
            }

            const vimeoID = $(this).attr('data-vimeoID'),
                embedWidth = $(this).attr('data-embedWidth'),
                embedHeight = $(this).attr('data-embedHeight');
            let inLineStyle = '';
            if (embedWidth && embedHeight) {
                inLineStyle = ' style="width:' + embedWidth + 'px;height:' + embedHeight + 'px;"';
            }
            const iframeId = 'vimeo-iframe-' + vimeoID;
            $(this).css('background-image', 'none');
            $(this).attr('data-triggered', 'true');
            $(this).html(
                '<iframe src="https://player.vimeo.com/video/' + vimeoID + '?autoplay=1&title=0&byline=0&portrait=0&color=ff9933&fullscreen=1&transparent=0&playsinline=0"' +
                ' frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen ' +
                inLineStyle +
                ' id="' + iframeId + '"' +
                ' allow="autoplay"' +
                ' playsinline="false"' +
                " ></iframe>"
            );
            // playsinline - default "true" - Play video inline on mobile devices, to automatically go fullscreen on playback set this parameter to false.

            $(this).fitVids();
        });
    }


});

$(function() {
    if ($('.JITWebinarPage_live').length) {
        var jitWebinarMsTimestamp = false,
            jitTimeInVideoWebinarStartsMs = 0,
            jitWebinarVideoStartsMsTimestamp = 0,
            hasPressedPlay = false,
            skipOnplayCallback = false,
            vimeoPlayer = false,
            modalVimeoPlayer = false,
            botMessages = [
                {
                    type: 'welcome',
                    message:  function(nickname) {
                        return hpaTranslatedtext.jitWebinar.welcomeMessageChatReplay.replace('%s', nickname); // Welcome along <b>%s</b>, enjoy the lesson! — Just so you know, this chat is a replay. However, put any well worded questions you have in here and we will reply via email.
                    },
                    sent: false,
                    wait: 1000,
                    canSend: function() {
                        // const msFromStart = jitWebinarMsTimestamp - Date.now();
                        // let canSend = false;
                        //
                        // if (msFromStart > 0 && msFromStart < 1800000) {
                        //     canSend = true;
                        // }
                        //
                        // return canSend;

                        return true;
                    }
                }
            ],
            jitWebinarLiveModal = $('#jitWebinarLiveModal');

        function runChatReplay() {
            const date = new Date();

            var chatMessageDirection = ($(window).width() < 992) ? 'top' : 'bottom';
            var n = 0,
                m = chat.length,
                msTimestamp = date.getTime();
            var messages = [];
            var allMessages = [ ...chat ];
            for (n = 0; n < m; n++) {
                const chatItem = allMessages[n];
                if (chatItem.msTimestamp < msTimestamp) {
                    messages.push(chatItem);
                    chat.shift();
                }
            }
            if (messages.length) updateMessages(messages);

            setTimeout(function() {
                runChatReplay();
            }, 2000);
        }

        function countdownTimerLive() {
            setTimeout(function() {
                const date = new Date();
                $('.js-countdown-timer').html(countdown(new Date(jitWebinarMsTimestamp)).toString());
                if (date.getTime() < jitWebinarVideoStartsMsTimestamp) { // The video might start 30 mins before the webinar
                    countdownTimerLive();
                } else {
                    vimeoPlayer.play();
                    showPart('video');
                }
            }, 1000);
        }

        function countdownTimerLiveModal() {
            setTimeout(function() {
                const date = new Date();
                let reRunFunc = false;
                if (jitWebinarMsTimestamp !== false) {
                    if (date.getTime() < jitWebinarMsTimestamp) { // Lesson Starts in
                        $('.js-countdown-timer-modal').html(hpaTranslatedtext.jitWebinar.lessonStartsInPrefix + countdown(new Date(jitWebinarMsTimestamp)).toString());
                        reRunFunc = true;
                    }
                } else {
                    reRunFunc = true;
                }
                if (reRunFunc) {
                    countdownTimerLiveModal();
                }
            }, 1000);
        }

        function showPart(show) {
            if (show === 'loading') {
                $('.liveEmbedder .loading').show();
                $('.liveEmbedder .countdown-timer').hide();
                $('.liveEmbedder .finished').hide();
                // $('.liveEmbedder .video-mask').hide();
                $('.liveEmbedder .video-mask .vimeo-video-wrapper iframe').css('visibility', 'hidden');
            } else if (show === 'video') {
                $('.liveEmbedder .loading').hide();
                $('.liveEmbedder .countdown-timer').hide();
                $('.liveEmbedder .finished').hide();
                // $('.liveEmbedder .video-mask').show();
                $('.liveEmbedder .video-mask .vimeo-video-wrapper iframe').css('visibility', 'visible');
            } else if (show === 'countdown-timer') {
                $('.liveEmbedder .loading').hide();
                $('.liveEmbedder .countdown-timer').show();
                $('.liveEmbedder .finished').hide();
                // $('.liveEmbedder .video-mask').hide();
                $('.liveEmbedder .video-mask .vimeo-video-wrapper iframe').css('visibility', 'hidden');
            } else if (show === 'finished') {
                $('.liveEmbedder .loading').hide();
                $('.liveEmbedder .countdown-timer').hide();
                $('.liveEmbedder .finished').show();
                // $('.liveEmbedder .video-mask').hide();
                $('.liveEmbedder .video-mask .vimeo-video-wrapper iframe').css('visibility', 'hidden');
            }
        }

        function showChatPopups() {
            if (jitWebinarMsTimestamp !== false) {
                var chatPopupFB = $('.fbshare-box'),
                    chatPopupFBExists = chatPopupFB.length,
                    chatPopupFBShowTime = 0,
                    chatPopupFBShowMsTimestamp = jitWebinarMsTimestamp,
                    chatPopupSales = $('.course-sales-box'),
                    chatPopupSalesExists = chatPopupSales.length,
                    chatPopupSalesShowTime = 0,
                    chatPopupPressPlay = $('.press-play-box'),
                    chatPopupPressPlayVisible = chatPopupPressPlay.is(':visible'),
                    chatPopupSalesShowMsTimestamp = jitWebinarMsTimestamp;

                if (hasPressedPlay) {
                    if (chatPopupPressPlayVisible) {
                        chatPopupPressPlay.hide();
                        if (chatMessageDirection === 'top') {
                            updateFirstMessageMarginTop();
                        }
                    }

                    if (chatPopupFBExists) {
                        chatPopupFBShowTime = parseInt(chatPopupFB.data('show-time'));
                        if (isNaN(chatPopupFBShowTime)) chatPopupFBShowTime = 0;
                        chatPopupFBShowMsTimestamp = jitWebinarMsTimestamp + convertSecondsToMs(chatPopupFBShowTime);
                    }

                    if (chatPopupSalesExists) {
                        chatPopupSalesShowTime = parseInt(chatPopupSales.data('show-time'));
                        if (isNaN(chatPopupSalesShowTime)) chatPopupSalesShowTime = 0;
                        chatPopupSalesShowMsTimestamp = jitWebinarMsTimestamp + convertSecondsToMs(chatPopupSalesShowTime);
                    }

                    if (chatPopupSalesExists && chatPopupSales.is(':hidden') && chatPopupSalesShowMsTimestamp < Date.now()) {
                        // chatPopupSalesBoxCountdownTimer();
                        chatPopupFB.hide();
                        chatPopupSales.show();

                        if (chatMessageDirection === 'top') {
                            updateFirstMessageMarginTop();
                        } else {
                            var outerHeight = chatPopupSales.outerHeight(true) + 10;
                            $('.messages *').first().css('margin-top', outerHeight + 'px');
                        }

                        return true;
                    } else if (chatPopupFBExists && chatPopupFB.is(':hidden') && chatPopupFBShowMsTimestamp < Date.now()) {
                        chatPopupFB.show();
                        chatPopupSales.hide();

                        if (chatMessageDirection === 'top') {
                            updateFirstMessageMarginTop();
                        } else {
                            var outerHeight = chatPopupFB.outerHeight(true) + 10;
                            $('.messages *').first().css('margin-top', outerHeight + 'px');
                        }
                    }
                } else {
                    chatPopupPressPlay.show();
                    if (chatMessageDirection === 'top') {
                        updateFirstMessageMarginTop();
                    } else {
                        var outerHeight = chatPopupPressPlay.outerHeight(true) + 10;
                        $('.messages *').first().css('margin-top', outerHeight + 'px');
                    }
                }
            }

            setTimeout(function() {
                showChatPopups();
            }, 2000);
        }

        if (jitTimeInVideoWebinarStarts > 0) {
            jitTimeInVideoWebinarStartsMs = convertSecondsToMs(jitTimeInVideoWebinarStarts);
        }

        const jitToggleChat = $('.jit-toggle-chat');
        if (jitToggleChat.length) {
            jitToggleChat.on('click', function() {
                const $this = $(this),
                    altText = $this.data('alt-text'),
                    currentText = $this.text();

                $this.data('alt-text', currentText).text(altText);

                $('.chat.panel-body .chat-content').toggle();

                $newMessagePrompt.trigger('click');
            });
        }

        const promoWebinarPage = $('.webinarPromotionalChat'),
            pageClass = promoWebinarPage.data('pageclass'),
            pageID = promoWebinarPage.data('pageid');
        var chat = false;

        var $chatContainer = $("#js-chatContainer");
        var $chatInput = $("#js-chatInput");
        var $chatNum = $("#js-chatNum");
        var $newMessagePrompt = $("#js-newMessagePrompt");

        var nickname = $chatContainer.data('chatnickname');

        // state controls
        var autoScroll = true;

        hideScrollMessage();

        var alreadyJoined = sessionStorage.getItem("alreadyJoined") || false;

        var chatMessageDirection = ($(window).width() < 992) ? 'top' : 'bottom';

        if (chatMessageDirection === 'top') {
            $newMessagePrompt.find('button').html('New Messages Above');
            $newMessagePrompt.css('top', '14px');
            $newMessagePrompt.css('bottom', 'auto');
        } else { // New Messages Above
            $newMessagePrompt.find('button').html(hpaTranslatedtext.jitWebinar.newMessagesAbove);
        }

        $.get(jitWebinarPageLink + 'chat/?_=' + Date.now(), function(data) {
            if (data.status === 1) {
                jitWebinarMsTimestamp = data.jitWebinarMsTimestamp;
                jitWebinarVideoStartsMsTimestamp = jitWebinarMsTimestamp - jitTimeInVideoWebinarStartsMs; // the video could start 30 mins before the webinar if we are showing a countdown timer in the video
                // var date1 = new Date(jitWebinarMsTimestamp);
                // console.log(date1.toString());
                // var date2 = new Date(jitWebinarVideoStartsMsTimestamp);
                // console.log(date2.toString());

                chat = data.chat;
                runChatReplay();

                const messages = [];
                messages.push({
                    messageType: 'userJoinedChat',
                    message: hpaTranslatedtext.jitWebinar.userHasJoined.replace('%s', nickname), // %s has joined
                    isModerator: 0,
                    nickname: nickname,
                    email: '',
                    datetime: '',
                });

                let memebersInChat = parseInt($chatNum.text());
                if (!isNaN(memebersInChat) && memebersInChat === 0) { // only need to do this if no members in chat
                    messages.push({
                        messageType: 'count',
                        message: 0, // send 0 because we always add 1 to the chat count for the live user
                        isModerator: 0,
                        nickname: '',
                        email: '',
                        datetime: '',
                    });
                }

                updateMessages(messages);

                showPart('video');
            }
        }, 'json');

        // controlVideo();

        $newMessagePrompt.on("click", function(e) {
            scrollToLastMessage();
        });

        function scrollToLastMessage() {
            if (chatMessageDirection === 'bottom') {
                $(".chat .messages").scrollTo(".message:last", 100, {
                    onAfter: function() {
                        hideScrollMessage();
                    }
                });
            } else {
                $(".chat .messages").animate({ "scrollTop": 0 });
                hideScrollMessage();
            }
            autoScroll = true;
        }

        function hideScrollMessage() {
            $newMessagePrompt.hide();
        }

        function showScrollMessage() {
            $newMessagePrompt.show();
        }

        $(".messages").on("scroll", function(e) {
            var $this = $(this);
            if (chatMessageDirection === 'top') {
                var lastMessagePos = $this.find(".message:first").position().top;
                if (lastMessagePos < 0) {
                    autoScroll = false;
                } else {
                    autoScroll = true;
                    hideScrollMessage();
                }
            } else {
                var height = $this.height();
                var lastMessagePos = $this.find(".message:last").position().top;
                if (lastMessagePos > height) {
                    autoScroll = false;
                } else {
                    autoScroll = true;
                    hideScrollMessage();
                }
            }
        });

        // submit the message when enter is Pressed
        $chatInput.emojioneArea({
            pickerPosition: (chatMessageDirection == 'top' ? 'bottom' : 'top'),
            attributes: {
                spellcheck: true
            },
            events: {
                keyup: function(editor, event) {
                    if (event.which === 13) {
                        submitChat(this.getText());
                    }
                }
            }
        });

        // submit the message when the Send Button is pressed
        $chatContainer.submit(function(e) {
            e.preventDefault();
            submitChat($chatInput.val());
            return false;
        });

        function addLinks(text) {
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function(url) {
                return '<a target="_blank" href="' + url + '">' + url + "</a>";
            });
        }

        function submitChat(message) {
            // clear text field
            $chatInput.val("");
            $(".emojionearea-editor").empty();
            // check if the message contains at least one non white space
            if (!/\S/.test(message)) {
                return false;
            }

            const chatboxForm = $('#js-chatContainer');
            let loginHash = chatboxForm.data('login-hash'),
                postUrl = chatboxForm.attr('action') + 'saveChatMessage?l=' + loginHash + '&_=' + Date.now(),
                formData = 'message=' + encodeURIComponent(message);

            $.post(postUrl, formData, function(data) {
                // console.log(data);
            }, 'json');

            //basic check to see if its a link, and put into a a tag
            message = addLinks(message);

            const messageObject = {
                messageType: 'chat',
                message: message,
                isModerator: '0',
                nickname: nickname,
                email: '',
                datetime: '',
            };

            updateMessages([messageObject]);

            const welcomeMessage = botMessages.find(botMessage => (botMessage.type === 'welcome' && botMessage.sent === false && botMessage.canSend() === true));
            if (welcomeMessage) {
                messageObject.message = welcomeMessage.message(nickname);
                messageObject.isModerator = '1';
                messageObject.nickname = 'HPA Bot';
                welcomeMessage.sent = true;

                setTimeout(function() {
                    updateMessages([messageObject]);
                }, welcomeMessage.wait);
            }

            var $button = $(".emojionearea-button");
            if ($button.hasClass("active")) {
                // close the Emoji picker if it is open
                $(".emojionearea-button").trigger("click");
            }
        }

        function updateMessages(messages) {
            var html,
                selector = $(".chat .messages");

            html = "";

            if (messages.length < 1) {
                return;
            }

            if (chatMessageDirection === 'top') {
                messages.reverse();
            }

            messages.forEach(function(messageObject) {
                if (messageObject.messageType === "count") {
                    let memebersInChat = parseInt(messageObject.message);
                    if (!isNaN(memebersInChat)) {
                        memebersInChat += 1; // add 1 to include the live user
                        $chatNum.text(memebersInChat);
                    }
                } else if (messageObject.messageType === "userJoinedChat") {
                    html += '<p class="message-userJoined">' + messageObject.message + "</p>";
                } else if (messageObject.messageType === "userBanned") {
                    html += '<p class="message-userBanned">' + messageObject.message + "</p>";
                } else if (messageObject.messageType === "userUnbanned") {
                    html += '<p class="message-userUnbanned">' + messageObject.message + "</p>";
                } else if (messageObject.messageType === "chat") {
                    // console.log("messageObject", messageObject);
                    var admin = messageObject.isModerator === "1" ? " admin" : "";

                    // '<small>' + messageObject.datetime + '</small><br>' +
                    html += '<section class="message' + admin + '" data-id="' + messageObject.id + '">';
                    html +=
                        '<p class="message-description">' +
                        '<span class="nick">' +
                        messageObject.nickname +
                        ': </span>' +
                        messageObject.message +
                        '</p>';
                    html += '</section>';
                }
            });

            if (chatMessageDirection === 'top') {
                selector.prepend(html);
                updateFirstMessageMarginTop();
            } else {
                selector.append(html);
            }

            if (autoScroll) {
                scrollToLastMessage();
            } else {
                showScrollMessage();
            }
        }

        function updateFirstMessageMarginTop() {
            if (chatMessageDirection !== 'top') return;

            var currentBoxElement = $('.chat-popup-box:visible'),
                chatElements = $('.live-chat .panel .panel-body .chat-content .messages *'),
                messageElements = $('.live-chat .panel .panel-body .chat-content .messages .message'),
                userJoinedElements = $('.live-chat .panel .panel-body .chat-content .messages .message-userJoined'),
                firstElement = chatElements.first(),
                marginTop = 10;

            messageElements.css('margin-top', marginTop + 'px');
            userJoinedElements.css('margin-top', '0px');

            if (currentBoxElement.length) {
                var outerHeight = currentBoxElement.outerHeight(true) + marginTop;
                firstElement.css('margin-top', outerHeight + 'px');
                $newMessagePrompt.css('top', outerHeight + 'px');
            }

        }

        showChatPopups();

        function chatPopupSalesBoxCountdownTimer() {
            const date = new Date();
            $('.chatPopupSalesBox-countdown-timer').html(countdown(new Date(jitWebinarMsTimestamp + convertSecondsToMs(60*60*72))).toString());
            // if (date.getTime() < jitWebinarMsTimestamp) {
            //     countdownTimerLive();
            // }
            setTimeout(function() {
                chatPopupSalesBoxCountdownTimer();
            }, 1000);
        };
        chatPopupSalesBoxCountdownTimer();

        var skipToLive = function() {
            // console.log('play has already been pressed ' + hasPressedPlay);
            var playerTime = convertMsToSeconds(Date.now() - jitWebinarVideoStartsMsTimestamp);
            // console.log('vimeoPlayer.setCurrentTime');
            vimeoPlayer.setCurrentTime(playerTime).then(function(seconds) {
              // `seconds` indicates the actual time that the player seeks to
              // console.log('player set to ' + seconds + ' seconds');
            }).catch(function(error) {
                console.log(error);
            });
        }

        var checkLiveStatus = function() {
            // console.log('running live status func');
            if (hasPressedPlay) {
                // console.log('checking live status');
                // $('.skip-to-live').css('visibility', 'visible'); // Don't want it to show at all now
                let currentTime = convertMsToSeconds(Date.now() - jitWebinarVideoStartsMsTimestamp);
                vimeoPlayer.getCurrentTime().then(function(playerCurrentTime) {
                    // console.log('playerCurrentTime', playerCurrentTime);
                    // console.log(currentTime);
                    // console.log(playerCurrentTime);
                    if (currentTime > (playerCurrentTime + 3)) {
                        // console.log('not live');
                        $('.skip-to-live').removeClass('is-live');
                    } else {
                        // console.log('is live');
                        $('.skip-to-live').addClass('is-live');
                    }
                    // console.log(" ");
                    setTimeout(checkLiveStatus, 500);
                }).catch(function(error) {
                    console.log(error);
                });
            } else {
                setTimeout(checkLiveStatus, 500);
            }
        };

        const vimeoIframeID = 'vimeo-iframe-' + $('.vimeo-video-wrapper').data('vimeo-video-id'),
            vimeoIframe = $('#' + vimeoIframeID);
        if (vimeoIframe.length) {
            vimeoPlayer = new vimeoPlayerImport(vimeoIframe);
            vimeoPlayer.setVolume(1);
        }

        if (jitWebinarLiveModal.length) {
            const modalVimeoIframeID = 'model-vimeo-iframe-' + jitWebinarLiveModal.find('.click-to-play-image').data('vimeo-video-id'),
                modalVimeoIframe = $('#' + modalVimeoIframeID);
            if (modalVimeoIframe.length) {
                modalVimeoPlayer = new vimeoPlayerImport(modalVimeoIframe);
                modalVimeoPlayer.on('play', function (obj) {
                    modalVimeoPlayer.setVolume(0);
                    jitWebinarLiveModal.modal('hide');
                    modalVimeoPlayer.pause();
                    vimeoPlayer.play();
                });
            }
        }

        if (vimeoIframe.length) {
            // vimeoPlayer = new vimeoPlayerImport(vimeoIframe);
            // vimeoPlayer.setVolume(1);
            vimeoPlayer.on('ended', function(obj) {
                showPart('finished');
            });
            var onPlayVideo = function(obj) {
                // console.log(obj);
                // console.log('onPlay');
                // console.log('skipOnplayCallback', skipOnplayCallback);
                if (skipOnplayCallback) {
                    skipOnplayCallback = false;
                    return;
                }
                // console.log('hasPressedPlay', hasPressedPlay);
                if (!hasPressedPlay) {

                    const $jitWebinarAttended = $('#js_jitWebinarAttended');
                    if ($jitWebinarAttended.length) {
                        if (window.GtmDefined) {
                            let webinarName = $jitWebinarAttended.data('webinar-name'),
                                webinarStartTime = $jitWebinarAttended.data('webinar-start-time');
                            if (webinarName !== '' && webinarStartTime !== '') {
                                const data = {
                                    event: 'jitWebinarAttended',
                                    detail: {
                                        webinarName: webinarName,
                                        webinarStartTime: webinarStartTime
                                    }
                                };
                                // console.log(data);
                                window.dataLayer.push(data);
                            }
                        }
                    }

                    showPart('loading');
                    // console.log('showPart', 'loading');
                    vimeoPlayer.pause();
                    // console.log('vimeoPlayer', 'paused');
                    if (Date.now() > jitWebinarVideoStartsMsTimestamp) {
                        vimeoPlayer.getDuration().then(function(duration) {
                            let playerTime = convertMsToSeconds(Date.now() - jitWebinarVideoStartsMsTimestamp);
                            // console.log('playerTime', playerTime);
                            // console.log('duration', duration);
                            if (playerTime < duration) {
                                // wasn't working when inside vimeoPlayer.setCurrentTime on chrome
                                skipOnplayCallback = true;
                                vimeoPlayer.play();
                                // console.log('vimeoPlayer', 'play');
                                showPart('video');
                                // console.log('showPart', 'video');

                                vimeoPlayer.setCurrentTime(playerTime).then(function(seconds) {
                                  // `seconds` indicates the actual time that the player seeks to
                                  // console.log('Player started at ' + seconds + ' seconds');

                                }).catch(function(error) {
                                    console.log(error);
                                });
                            } else {
                                showPart('finished');
                            }
                        }).catch(function(error) {
                            // console.log(error);
                        });
                    } else {
                        showPart('countdown-timer');
                        // console.log('showPart', 'countdown-timer');
                        countdownTimerLive();
                    }
                    hasPressedPlay = true;
                } else {
                    // Don't do this because we will now rely on the "Live" link under the video. Google optimize clears the on play listner so we will use the Live link method for now.
                    // 20210923 do want to do this now. Don't want people to be able to pause the video
                    // 2025-10-18 We don't want them to be able to skip so I made a few fixes in skipToLive so that it will work correctly.
                    skipToLive();
                }
            };
            vimeoPlayer.on('play', onPlayVideo);
            // vimeoPlayer.on('pause', function(obj) {
            //     if (hasPressedPlay && Date.now() > jitWebinarVideoStartsMsTimestamp) {
            //         vimeoPlayer.play();
            //     }
            // });
            vimeoPlayer.on('error', function(obj) {
                console.log(obj);
            });

            checkLiveStatus();

            $('.skip-to-live').on('click', function() {
                var $this = $(this);
                if (hasPressedPlay && Date.now() > jitWebinarVideoStartsMsTimestamp) {
                    if (!$this.hasClass('is-live')) {
                        $this.addClass('is-live');
                        skipToLive();
                    }
                }
            });
        }

        if (jitWebinarLiveModal.length) {
            jitWebinarLiveModal.modal('show');
            countdownTimerLiveModal();
        }

    } // if ($('.JITWebinarPage_live').length)

});



// WEBPACK FOOTER //
// ./js/modules/jitWebinar.js